<template>
    <section id="DarsSection" class="dars card">
        <h2 id="dars-header" class="card-header">
            <a id="darsanchor" name="darsanchor"></a>
            <button class="btn btn-link" data-toggle="collapse" data-target=".dars-card-body" aria-expanded="true" aria-controls="dars-card-body" @click="collapsePanel" aria-label="Toggle DARS Section (Mobile View)">
                <span class="icon icon-graduation-cap"></span>
                Degree Progress
            </button>
        </h2>
        <div class="dars-card-body card-body collapse" aria-labelledby="dars-header" id="dars-card-body">
            <p>Produce an unofficial audit of progress toward your undergraduate degree. Visit the Registrar's <a href="https://registrar.illinois.edu/academic-records/dars-audit/" target="_blank">Degree Audit</a> page for information about what you will see on the audit and how to either run a different program or add hypothetical courses before running an audit.</p>
            <p><a href="https://uachieve.apps.uillinois.edu/uachieve_uiuc/" class="btn btn-primary" target="_blank">Generate audit</a></p>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Dars"
    }
</script>